/**
 * MandatairesBanner — Bandeau professionnel de crédibilité affichant
 * les logos officiels des organismes dont ECONATION est mandataire.
 * Design institutionnel type gouv.fr / France Rénov'.
 */

const MPR_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_efficiency-certified/artifacts/ne6txy5q_maprimerenov-gouv-fr-2020.png";

const ANAH_LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_efficiency-certified/artifacts/cusi1wzu_Anah.png";

export default function MandatairesBanner({ theme = "dark" }) {
  const isDark = theme === "dark";

  return (
    <div
      data-testid="mandataires-banner"
      className={`inline-block max-w-full rounded-2xl ${
        isDark
          ? "bg-white/[0.94] backdrop-blur-md border border-white/20 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.35)]"
          : "bg-white border border-slate-200 shadow-md"
      } px-5 sm:px-7 py-4 sm:py-5`}
    >
      {/* Caption */}
      <div className="flex items-center justify-center gap-2 mb-3 sm:mb-4">
        {/* Cocarde tricolore */}
        <div className="flex items-center gap-0.5" aria-hidden="true">
          <span className="inline-block h-2 w-2 rounded-full bg-[#0055A4]" />
          <span className="inline-block h-2 w-2 rounded-full bg-white border border-slate-300" />
          <span className="inline-block h-2 w-2 rounded-full bg-[#EF4135]" />
        </div>
        <span className="text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.28em] text-slate-700">
          Mandataire officiel
        </span>
      </div>

      {/* Logos */}
      <div className="flex items-center justify-center gap-5 sm:gap-8 lg:gap-10">
        {/* MaPrimeRénov' */}
        <div className="flex items-center justify-center h-12 sm:h-14 lg:h-16" data-testid="mandataires-logo-mpr">
          <img
            src={MPR_LOGO}
            alt="MaPrimeRénov' — République Française"
            className="h-full w-auto object-contain"
            loading="lazy"
          />
        </div>

        {/* Séparateur */}
        <div className="h-8 sm:h-10 w-px bg-slate-200" aria-hidden="true" />

        {/* Anah */}
        <div className="flex items-center justify-center h-12 sm:h-14 lg:h-16" data-testid="mandataires-logo-anah">
          <img
            src={ANAH_LOGO}
            alt="Agence Nationale de l'Habitat (Anah)"
            className="h-full w-auto object-contain"
            loading="lazy"
          />
        </div>

        {/* Séparateur */}
        <div className="h-8 sm:h-10 w-px bg-slate-200" aria-hidden="true" />

        {/* CEE — Badge officiel stylisé (pas de logo unique existant) */}
        <div className="flex flex-col items-center justify-center h-12 sm:h-14 lg:h-16" data-testid="mandataires-logo-cee">
          <div className="font-display font-bold text-[#0055A4] text-2xl sm:text-3xl lg:text-[38px] leading-none tracking-tight">
            CEE
          </div>
          <div className="mt-1 text-[8px] sm:text-[9px] font-semibold uppercase tracking-[0.14em] text-slate-500 text-center leading-tight">
            Certificats d&apos;économies<br/>d&apos;énergie
          </div>
        </div>
      </div>

      {/* Footer text */}
      <div className="mt-3 sm:mt-4 text-center text-[10px] sm:text-[11px] text-slate-500 leading-relaxed">
        ECONATION accompagne vos dossiers auprès de l&apos;État français.
      </div>
    </div>
  );
}
